module.exports = __webpack_public_path__ + "media/502sim.d51411c1.mp4";